// extracted by mini-css-extract-plugin
export default {"root":"styles_root__UIenW","iconTop":"styles_iconTop__PBFTT","title":"styles_title__hVKEE","contentMain":"styles_contentMain__kReVp","buttonAction":"styles_buttonAction__cYppg"};